// extracted by mini-css-extract-plugin
module.exports = {"container":"Turnout_container__20iii","header":"Turnout_header__3hVT_","slider":"Turnout_slider__8BDVY"};